// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"47f72fab","709":"6f4ec937","809":"f73269dd"}[chunkId] + ".chunk.css";
};